<section class="error-404">
  <div class="wrapper">
    <h1 class="error-404-title">404</h1>
    <p class="error-404-desc">Sajnáljuk, a keresett oldal nem található</p>
    <p class="error-404-desc">kérjük próbálja megkeresni a főoldalról vagy a menüből</p>
    <a class="error-404-back-button" [routerLink]="['/']">Vissza a főoldalra</a>
  </div>
</section>
